import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "bf-modal bf-modal--voucher-redemption bf-modal--has-sections" }
const _hoisted_2 = { class: "bf-modal__section" }
const _hoisted_3 = { class: "d-flex justify-content-between mb-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "bf-heading-script text-primary mb-3" }, "Gutschein einlösen", -1)
const _hoisted_5 = { class: "flex-shrink-0" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "bf-voucher-redemption-overlay__loading-indicator" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-3x fa-spin fa-spinner" })
], -1)
const _hoisted_9 = { class: "bf-voucher-redemption-overlay__content" }
const _hoisted_10 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_11 = {
  key: 1,
  class: "mt-5"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center align-items-center text-success mt-4 mb-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-check-square fa-4x" }),
  /*#__PURE__*/_createElementVNode("div", { class: "h3 ps-3" }, "Der Gutschein wurde erfolgreich eingelöst!")
], -1)
const _hoisted_13 = { class: "d-flex justify-content-center mt-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VoucherCheck = _resolveComponent("VoucherCheck")!
  const _component_ProductCard = _resolveComponent("ProductCard")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    modelValue: _ctx.shownLocal,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.shownLocal) = $event)),
    close: _ctx.closeModal
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("a", {
                href: "#",
                class: "modal-close-button",
                "aria-label": "Schließen",
                onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)), ["prevent"]))
              }, _hoisted_7)
            ])
          ]),
          (!_ctx.showSuccess)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["bf-voucher-redemption-overlay", {'bf-voucher-redemption-overlay--loading': _ctx.loadingRedemption}]),
                ref: "redemptionOverlay"
              }, [
                _hoisted_8,
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_VoucherCheck, {
                    context: "free",
                    "button-label": "Überprüfen",
                    onValid: _ctx.onValidVoucher,
                    onInvalid: _cache[1] || (_cache[1] = ($event: any) => (_ctx.result = null)),
                    onReset: _cache[2] || (_cache[2] = ($event: any) => (_ctx.result = null))
                  }, null, 8, ["onValid"]),
                  (_ctx.result)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createVNode(_component_ProductCard, {
                          product: _ctx.result.product,
                          classes: {'h-100': true},
                          "show-price": false,
                          "show-region": true,
                          "enable-order-button": true,
                          "order-button-label": "Gutschein einlösen",
                          onOrderButtonClicked: _ctx.submitRedemption
                        }, null, 8, ["product", "onOrderButtonClicked"])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ], 2))
            : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("a", {
                    href: "#",
                    class: "btn btn-secondary",
                    onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)), ["prevent"]))
                  }, "Schließen")
                ])
              ]))
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "close"]))
}